// Example starter JavaScript for disabling form submissions if there are invalid fields
const toggleButton = (function (window, jQuery) {
	"use strict";

	if (!jQuery) {
		console.log('Toggle Button requires jQuery. Make sure it is referenced.');
		return;
	}

	jQuery('.toggle-button').on('click', function (e) {
		e.preventDefault();

		let $this = jQuery(this);

		let idToToggle = $this.data('toggle-id');
		let toggleState = $this.data('toggle-state');
		let btnTextOn = $this.data('toggle-text-on');
		let btnTextOff = $this.data('toggle-text-off');
		let funcToggleOn = $this.data('on-toggle-on');
		let funcToggleOff = $this.data('on-toggle-off');

		if (toggleState.toLowerCase() === 'on') {
			$this.html(btnTextOff);
			$this.data('toggle-state', 'off');
			jQuery(idToToggle).slideUp(250);

			if (funcToggleOff && typeof window[funcToggleOff] === 'function') {
				window[funcToggleOff]();
			}
		}
		else {
			$this.html(btnTextOn);
			$this.data('toggle-state', 'on');
			jQuery(idToToggle).slideDown(250);

			if (funcToggleOn && typeof window[funcToggleOn] === 'function') {
				window[funcToggleOn]();
			}
		}
	});

})(window, jQuery);

export default toggleButton;
